import { graphql } from "~/gql";

export const CREATE_OR_UPDATE_MATTER_COMPLETION_LOG = graphql(/* GraphQL */ `
  mutation CreateOrUpdateMatterCompletionLog($matterId: Float!, $completionPercentage: Float!) {
    createOrUpdateMatterCompletionLog(
      matterId: $matterId
      completionPercentage: $completionPercentage
    ) {
      id
      matterId
      completionPercentage
      createdAt
    }
  }
`);
